import { render, staticRenderFns } from "./Facilities.vue?vue&type=template&id=624bd3a0&"
import script from "./Facilities.vue?vue&type=script&lang=js&"
export * from "./Facilities.vue?vue&type=script&lang=js&"
import style0 from "./Facilities.vue?vue&type=style&index=0&id=624bd3a0&prod&lang=css&"
import style1 from "./Facilities.vue?vue&type=style&index=1&id=624bd3a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports